module.exports = __webpack_public_path__ + "static/media/oval3.8b270f1c.svg";